/*
 * 再入荷通知（AMP Back in Stock）トリガーボタンの移設 — 位置のみ・表示制御と見た目には関与しない。
 * app embed はボタン #BIS_trigger を分割払いフォーム（価格直下）の内側へ自動注入するが、
 * 導線としては CTA 直下に置く（v1 アプリブロックの位置・オーナー確定 2026-07-08）。
 * 注入は同一ノードへの一度きりで、アプリの在庫連動トグル（inline display）はノード参照ベース＝
 * DOM 上の位置を移してもバリアント切替への追従は壊れない（ホスト版 dev テーマで実測 2026-07-08）。
 * 移設先は buy-buttons ブロック内の <product-form> 直後（CTA と在庫ステータス注記の下・
 * カートフォームの外）。app embed スクリプトとの実行順は不定のため、未注入なら
 * MutationObserver で現れるのを待って一度だけ移す。経緯の正本は docs/pdp_availability_status.md。
 */
(function () {
  function relocate() {
    var trigger = document.getElementById('BIS_trigger');
    if (!trigger) return false;
    var productForm = document.querySelector('.product__info-container product-form');
    if (productForm && productForm.nextElementSibling !== trigger) {
      productForm.insertAdjacentElement('afterend', trigger);
    }
    return true;
  }

  function init() {
    if (relocate()) return;
    var observer = new MutationObserver(function () {
      if (relocate()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
